export default __webpack_public_path__ + "static/media/bg-4000.ac19c464.jpeg";